import { DocumentNode, useMutation } from '@apollo/client';

export type DefaultResponse = {
  [key: string]: {
    message: string;
  } | null;
};

export const makeMutation = <Variables, Response = DefaultResponse>(
  mutation: DocumentNode,
) => () => {
  const [mutate] = useMutation<Response, Variables>(mutation);

  return (variables: Variables) => mutate({ variables });
};

export const getResponseMessage = (
  response: DefaultResponse | null | undefined,
  fallback: string,
) => Object.values(response || {})[0]?.message || fallback;
